module.exports = __webpack_public_path__ + "static/official_website_new/img/01.e01e8894.jpg";